export const kLanguages = {
  'ab': 'Abjasio',
  'aa': 'Afar',
  'af': 'Afrikáans',
  'ak': 'Akan',
  'sq': 'Albanés',
  'am': 'Amárico',
  'ar': 'Árabe',
  'an': 'Aragonés',
  'hy': 'Armenio',
  'as': 'Asamés',
  'av': 'Avaro',
  'ae': 'Avestan',
  'ay': 'Aymara',
  'az': 'Azerbaiyano',
  'bm': 'Bambara',
  'ba': 'Bashkir',
  'eu': 'Euskera',
  'be': 'Bielorruso',
  'bn': 'Bengalí',
  'bh': 'Bihari, idiomas',
  'bi': 'Bislama',
  'bs': 'Bosnio',
  'br': 'Bretón',
  'bg': 'Búlgaro',
  'my': 'Birmano',
  'ca': 'Catalán, Valenciano',
  'km': 'Camboyano',
  'ch': 'Chamorro',
  'ce': 'Checheno',
  'ny': 'Chichewa, Chewa, Nyanja',
  'zh': 'Chino',
  'cu': 'Eslavo eclesiástico antiguo, Búlgaro antiguo, Eslavo eclesiástico',
  'cv': 'Chuvasio',
  'kw': 'Córnico',
  'co': 'Corso',
  'cr': 'Cree',
  'hr': 'Croata',
  'cs': 'Checo',
  'da': 'Danés',
  'dv': 'Divehi, Dhivehi, Maldivian',
  'nl': 'Neerlandés, Flamenco',
  'dz': 'Dzongkha',
  'en': 'Inglés',
  'eo': 'Esperanto',
  'et': 'Estonio',
  'ee': 'Ewe',
  'fo': 'Feroés',
  'fj': 'Fiyiano',
  'fi': 'Finlandés',
  'fr': 'Francés',
  'ff': 'Fulah',
  'gd': 'Gaélico escocés, Gaélico',
  'gl': 'Gallego',
  'lg': 'Ganda',
  'ka': 'Georgiano',
  'de': 'Alemán',
  'ki': 'Gikuyu, Kikuyu',
  'el': 'Griego moderno',
  'kl': 'Groenlandés, Kalaallisut',
  'gn': 'Guaraní',
  'gu': 'Guyaratí',
  'ht': 'Haitiano, Criollo haitiano',
  'ha': 'Hausa',
  'he': 'Hebreo',
  'hz': 'Herero',
  'hi': 'Hindi',
  'ho': 'Hiri Motu',
  'hu': 'Húngaro',
  'is': 'Islandés',
  'io': 'Ido',
  'ig': 'Igbo',
  'id': 'Indonesio',
  'ia': 'Interlingua (Asociación Internacional de Lengua Auxiliar)',
  'ie': 'Occidental',
  'iu': 'Inuktitut',
  'ik': 'Inupiaq',
  'ga': 'Irlandés',
  'it': 'Italiano',
  'ja': 'Japonés',
  'jv': 'Javanés',
  'kn': 'Canarés',
  'kr': 'Kanuri',
  'ks': 'Cachemir',
  'kk': 'Kazajo',
  'rw': 'Kinyarwanda',
  'kv': 'Komi',
  'kg': 'Kongo',
  'ko': 'Coreano',
  'kj': 'Kuanyama, Kwanyama',
  'ku': 'Kurdo',
  'ky': 'Kirguís',
  'lo': 'Lao',
  'la': 'Latín',
  'lv': 'Letón',
  'lb': 'Luxemburgués',
  'li': 'Limburgués',
  'ln': 'Lingala',
  'lt': 'Lituano',
  'lu': 'Luba-Katanga',
  'mk': 'Macedonio',
  'mg': 'Malgache',
  'ms': 'Malayo',
  'ml': 'Malayalam',
  'mt': 'Maltés',
  'gv': 'Manés',
  'mi': 'Maorí',
  'mr': 'Marathi',
  'mh': 'Marshalés',
  'ro': 'Moldavo, Rumano',
  'mn': 'Mongol',
  'na': 'Nauruano',
  'nv': 'Navajo, Navaho',
  'nd': 'Ndebele del norte',
  'ng': 'Ndonga',
  'ne': 'Nepalí',
  'se': 'Sami del norte',
  'no': 'Noruego',
  'nb': 'Bokmål noruego',
  'nn': 'Nynorsk noruego',
  'ii': 'Yi de Sichuán, Nuosu',
  'oc': 'Occitano (después de 1500)',
  'oj': 'Ojibwa',
  'or': 'Oriya',
  'om': 'Oromo',
  'os': 'Osético, Osetio',
  'pi': 'Pali',
  'pa': 'Panyabí, Punjabi',
  'ps': 'Pastún, Pushto',
  'fa': 'Persa',
  'pl': 'Polaco',
  'pt': 'Portugués',
  'qu': 'Quechua',
  'rm': 'Romanche',
  'rn': 'Kirundi',
  'ru': 'Ruso',
  'sm': 'Samoano',
  'sg': 'Sango',
  'sa': 'Sánscrito',
  'sc': 'Sardo',
  'sr': 'Serbio',
  'sn': 'Shona',
  'sd': 'Sindhi',
  'si': 'Cingalés, Cingalés',
  'sk': 'Eslovaco',
  'sl': 'Esloveno',
  'so': 'Somalí',
  'st': 'Sotho del sur',
  'nr': 'Ndebele del sur',
  'es': 'Español, Castellano',
  'su': 'Sundanés',
  'sw': 'Suajili',
  'ss': 'Swati',
  'sv': 'Sueco',
  'tl': 'Tagalo',
  'ty': 'Tahitiano',
  'tg': 'Tayiko',
  'ta': 'Tamil',
  'tt': 'Tártaro',
  'te': 'Telugu',
  'th': 'Tailandés',
  'bo': 'Tibetano',
  'ti': 'Tigriña',
  'to': 'Tongano',
  'ts': 'Tsonga',
  'tn': 'Tswana',
  'tr': 'Turco',
  'tk': 'Turcomano',
  'tw': 'Twi',
  'ug': 'Uigur',
  'uk': 'Ucraniano',
  'ur': 'Urdu',
  'uz': 'Uzbeko',
  've': 'Venda',
  'vi': 'Vietnamita',
  'vo': 'Volapük',
  'wa': 'Valón',
  'cy': 'Galés',
  'fy': 'Frisón occidental',
  'wo': 'Wolof',
  'xh': 'Xhosa',
  'yi': 'Yidis',
  'yo': 'Yoruba',
  'za': 'Zhuang',
  'zu': 'Zulú',
};
